export default "/fonts/vendor/primeicons/primeicons.svg?c6e2053303524e39530c36f094129407";